var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "anti-loss-popup-wrap" }, [
    _c("div", { staticClass: "anti-loss-wrap", class: { active: _vm.show } }, [
      _c("div", { staticClass: "al-title", class: _vm.langkey }),
      _c("p", {
        staticClass: "al-subtitle",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t("subtitle_anti_loss", [
              `<span>${_vm.$t("subtitle_anti_loss_slot")}</span>`,
            ])
          ),
        },
      }),
      _c("div", { staticClass: "gift-code" }, [
        _c("span", [
          _vm._v(" " + _vm._s(_vm.$t("text_giftcode_anti_loss")) + " "),
          _c("em", [_vm._v("PLAYSOSONWEB")]),
        ]),
        _c("a", {
          staticClass: "btn-copy",
          attrs: { href: "javascript:;" },
          on: {
            click: function ($event) {
              return _vm.doCopy("PLAYSOSONWEB")
            },
          },
        }),
      ]),
      _c("div", { staticClass: "awards-list" }),
      _c("a", {
        staticClass: "btn-close",
        attrs: { href: "javascript:;" },
        on: { click: _vm.handleClose },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }